<section class="branch-register">
  <div class="branch-container">
    <span class="branch-title">
      {{ isEdition ? 'Editar colaborador' : 'Agregá un colaborador' }}
    </span>
    <form
      class="form-responsible d-flex flex-column gap-3"
      [formGroup]="form"
      (ngSubmit)="onSubmitEventHandler(form.value)"
      autocomplete="off"
    >
      <mat-form-field class="w-100 input-yaca">
        <mat-label>Nombre</mat-label>
        <input
          matInput
          (paste)="checkPaste($event)"
          (drop)="checkDrop($event)"
          (keypress)="checkPattern($event)"
          type="text"
          tabindex="1"
          formControlName="nombre"
          placeholder="Nombre"
          maxlength="50"
        />
        <mat-error *ngIf="form.get('nombre')?.invalid && form.get('nombre')?.touched"
          >{{ 'pages.responsibles.messages.name_invalid' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 input-yaca">
        <mat-label>Apellido</mat-label>
        <input
          (paste)="checkPaste($event)"
          (drop)="checkDrop($event)"
          (keypress)="checkPattern($event)"
          type="text"
          tabindex="2"
          matInput
          formControlName="apellido"
          placeholder="Apellido"
          maxlength="50"
        />
        <mat-error *ngIf="form.get('apellido')?.invalid && form.get('apellido')?.touched">
          {{ 'pages.responsibles.messages.last_name_invalid' | translate }}</mat-error
        >
      </mat-form-field>

      <mat-form-field class="w-100 input-yaca">
        <mat-label>E-mail</mat-label>
        <input type="text" tabindex="3" matInput formControlName="email" placeholder="E-mail" maxlength="50" />
        <mat-error *ngIf="true"> {{ 'pages.responsibles.messages.email_invalid' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 input-yaca">
        <mat-label>Rol</mat-label>
        <mat-select formControlName="rol" placeholder="Rol" tabindex="4">
          <mat-option [value]="'RESPONSABLE'">Responsable</mat-option>
          <mat-option [value]="'FINANCIERO'">Financiero</mat-option>
        </mat-select>
        <mat-error *ngIf="true">El rol es requerido</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 input-yaca mb-3" *ngIf="form.get('rol')?.value === 'RESPONSABLE'">
        <mat-select
          #branchOffice
          formControlName="sucursal"
          tabindex="4"
          [(value)]="branchOfficeSelect"
          name="sucursalName"
          multiple
          [placeholder]="translate('pages.responsibles.labels.branch')"
        >
          <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice.value">
            {{ branchOffice.display }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="true">{{ 'La sucursal es requerida' }}</mat-error>
      </mat-form-field>
      <div class="buttons-container">
        <button mat-stroked-button class="w-button button-back fiserv55" type="button" (click)="goBack()">
          Cancelar
        </button>
        <button
          mat-raised-button
          type="submit"
          class="fiserv55 button-submit"
          tabindex="0"
          color="primary"
          [disabled]="controlForm() || saving || form.touched === false"
        >
          <span *ngIf="!saving">Guardar</span>
          <mat-spinner *ngIf="saving" mode="indeterminate" diameter="25"></mat-spinner>
        </button>
      </div>
    </form>
  </div>
</section>
